'use client';

import { c as _c } from "react/compiler-runtime";
import { Drawer, Heading, TextPassage } from '@petsmart-ui/sparky';
import { useEffect, useId, useState } from 'react';
import { useAutoshipContentQuery } from '@libs/common-next';
import { parseRichText } from '@libs/contentful';
import { AutoshipInfoDrawerHeader } from './AutoshipInfoDrawerHeader';
import { isSkuMapRestricted } from './lib';
import './AutoshipInfoDrawer.scss';
type AutoshipInfoDrawerProps = {
  discountDisplay?: string;
  isFirstAutoshipEligible: boolean;
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isDrawerOpen: boolean) => void;
  dataLayerPushEvent?: () => void;
};
export const AutoshipInfoDrawer = props => {
  const $ = _c(36);
  const {
    isDrawerOpen,
    setIsDrawerOpen
  } = props;
  const {
    autoshipContent,
    autoshipMapRestrictedContent
  } = useAutoshipContentQuery();
  const headingId = useId();
  const [hasBeenRendered, setHasBeenRendered] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setHasBeenRendered(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isDrawerOpen || $[3] !== props) {
    t2 = () => {
      if (!isDrawerOpen) {
        return;
      }
      props.dataLayerPushEvent?.();
    };
    $[2] = isDrawerOpen;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isDrawerOpen) {
    t3 = [isDrawerOpen];
    $[5] = isDrawerOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== autoshipContent || $[8] !== autoshipMapRestrictedContent || $[9] !== props.discountDisplay) {
    t4 = isSkuMapRestricted(props.discountDisplay) ? autoshipMapRestrictedContent ?? autoshipContent : autoshipContent;
    $[7] = autoshipContent;
    $[8] = autoshipMapRestrictedContent;
    $[9] = props.discountDisplay;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const selectedContent = t4;
  if (!selectedContent || !hasBeenRendered) {
    return null;
  }
  const {
    header,
    footer,
    body
  } = selectedContent;
  let t5;
  if ($[11] !== footer) {
    t5 = footer ? parseRichText(footer) : null;
    $[11] = footer;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const parsedFooter = t5;
  let t6;
  if ($[13] !== body) {
    t6 = body ? parseRichText(body) : null;
    $[13] = body;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const parsedBody = t6;
  let t7;
  if ($[15] !== setIsDrawerOpen) {
    t7 = () => setIsDrawerOpen(false);
    $[15] = setIsDrawerOpen;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== header || $[18] !== headingId) {
    t8 = <Drawer.Header><Heading id={headingId} tagName="h2" size="headline" data-testid="drawer-title">{header}</Heading></Drawer.Header>;
    $[17] = header;
    $[18] = headingId;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== props) {
    t9 = <AutoshipInfoDrawerHeader {...props} />;
    $[20] = props;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== parsedBody) {
    t10 = <div className="autoship-info-drawer__static-content">{parsedBody}</div>;
    $[22] = parsedBody;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t9) {
    t11 = <Drawer.Body data-testid="drawer-body">{t9}{t10}</Drawer.Body>;
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== parsedFooter) {
    t12 = parsedFooter && <Drawer.Footer data-testid="drawer-footer"><TextPassage>{parsedFooter}</TextPassage></Drawer.Footer>;
    $[27] = parsedFooter;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== headingId || $[30] !== isDrawerOpen || $[31] !== t11 || $[32] !== t12 || $[33] !== t7 || $[34] !== t8) {
    t13 = <Drawer align="right" isActive={isDrawerOpen} onClose={t7} data-testid="autoship-info-drawer" className="autoship-info-drawer" ariaLabelledBy={headingId} dismissible={true}>{t8}{t11}{t12}</Drawer>;
    $[29] = headingId;
    $[30] = isDrawerOpen;
    $[31] = t11;
    $[32] = t12;
    $[33] = t7;
    $[34] = t8;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
};